@import "../config/_helpers";

.record-a-message-section {
	padding: 20px;
	background: var(--secondary-color-light-10);
	// border-radius: 5px;
	position: relative;
	.record-a-message-container {
		overflow: hidden;
		.record-a-message-track {
			position: relative;
			left: 0;
			transition: 0.2s left ease-in-out;
			display: flex;
			align-items: stretch;
			flex-wrap: nowrap;
			> div {
				margin-top: 10px;
				background: var(--secondary-color-light-8);
				border-radius: 5px;
				padding: 20px;
				flex: 0 0 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-content: center;
				align-items: center;
				@include at-breakpoint(0, $m) {
					padding: 10px;
				}
			}
		}
	}

	.callout {
		display: inline-block;
		background: var(--secondary-color);
		color: white;
		font-weight: bold;
		padding: 3px 10px;
		margin-left: 5px;
		font-size: small;
		border-radius: 5px;
		transition: 0.2s all ease-in-out;
		position: absolute;
		top: 5px;
		right: 5px;
	}
	.how-it-works {
		text-align: center;
		counter-reset: how-it-works;
		.how-it-works-step {
			counter-increment: how-it-works;
			position: relative;
			img {
				max-width: 100px;
				margin: 0 auto;
			}
			@include at-breakpoint(0, $m) {
				&:after {
					content: counter(how-it-works);
					background: var(--secondary-color-dark-1);
					color: var(--secondary-color-light-6);
					border-radius: 50%;
					width: 30px;
					aspect-ratio: 1/1;
					font-size: larger;
					display: flex;
					align-items: center;
					justify-content: center;
					position: absolute;
					right: 32%;
					top: 5%;
				}
			}
		}
	}
	.record-a-message-controls {
		height: 100%;
		display: flex;
		align-items: center;
		align-content: center;
		justify-content: center;
		flex-wrap: wrap;
		text-align: center;
		button {
			display: flex;
			padding: 5px 20px;
			align-items: center;
			align-content: center;
			justify-content: center;
			flex-direction: column;
			font-size: 10px;
			border-radius: 0;
			border: 1px solid rgba(0, 0, 0, 0.1);
			background: white;
			color: black;
			svg {
				display: block;
				font-size: 20px;
				margin: 0;
				margin-bottom: 5px;
			}
			&.back-button {
				background: rgba(0, 0, 0, 0.5);
				color: white;
			}
			&.save-button {
				background: var(--emphasis-color);
			}
			&:first-child {
				border-top-left-radius: 10px;
				border-bottom-left-radius: 10px;
			}
			&:last-child {
				border-top-right-radius: 10px;
				border-bottom-right-radius: 10px;
			}
		}
	}
	.actual-recording {
		.record-a-message-preview {
			background: black;
			width: 100%;
			max-width: 350px;
			aspect-ratio: 16/9;
			margin: 0 auto;
			border-radius: 5px;
			display: flex;
			align-items: center;
			justify-content: center;
			overflow: hidden;
			position: relative;
			.countdown {
				color: white;
				font-size: 72px;
				position: relative;
				z-index: 10;
			}
			video {
				position: absolute;
				inset: 0;
				width: 100%;
				height: 100%;
			}
		}

		&.recording {
			.record-a-message-preview {
				&:before {
					content: "\2022  REC";
					font-size: 20px;
					font-weight: bold;
					padding-left: 10px;
					padding-right: 10px;
					background: rgba(0, 0, 0, 0.3);
					color: red;
					position: absolute;
					top: 0;
					left: 0;
					z-index: 10;
					animation: blink 1s infinite alternate;
				}
			}
		}
	}
	.record-a-message-options {
		width: 100%;
		.record-a-message-container {
			.record-a-message-preview {
				video {
					max-width: 100%;
				}
			}
		}
	}
	.record-a-message-button {
		margin: 0 auto;
		padding: 10px 20px;
		border-radius: 5px;
		cursor: pointer;
		margin-top: 20px;
	}
	.message-complete {
		text-align: center;
		background: var(--quarternary-color-light-4) !important;
		button {
			display: block;
			margin: 0 auto;
			margin-top: 20px;
			width: fit-content;
		}
	}
}

@keyframes blink {
	from {
		color: transparent;
	}

	to {
		color: red;
	}
}
